import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {catchError, map, Observable, of} from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class PinholePromoCodeService {

    constructor(private httpClient: HttpClient) {

    }

    findPromoCode(code: string): Observable<PromoCode | null> {
        return this.httpClient.get<PromoCode>("/rest/admin/promo_code?code=" + code).pipe(
            catchError(() => of(null))
        )
    }

    getBatches(): Observable<Map<PromoCodeCategory, Batch[]> | null> {
        return this.httpClient.get<Record<string, Batch[]>>("/rest/admin/promo_code/batches").pipe(
            map(response => response ? new Map(Object.entries(response)) as Map<PromoCodeCategory, Batch[]> : null),
            catchError(() => of(null))
        );
    }

    getTypes(): Observable<string | null> {
        return this.httpClient.get<string>("/rest/admin/promo_code/types").pipe(
            catchError(() => of(null))
        )
    }

    getCategories(): Observable<string | null> {
        return this.httpClient.get<string>("/rest/admin/promo_code/categories").pipe(
            catchError(() => of(null))
        )
    }

    getStatistic(statisticData: StatisticData): Observable<Statistic> {
        return this.httpClient.post<Statistic>(`/rest/admin/promo_code/statistic`, statisticData);
    }

    generatePrivateCodes(privatePromoCodeGenerationData: PrivatePromoCodeGenerationData): Observable<string[]> {
        return this.httpClient.post<string[]>(`/rest/admin/promo_code/generate_private`, privatePromoCodeGenerationData);
    }

    createPublicCode(publicPromoCodeCreationData: PublicPromoCodeCreationData): Observable<void> {
        return this.httpClient.post<void>(`/rest/admin/promo_code/create_public`, publicPromoCodeCreationData);
    }
}

export type PromoCodeCategory = string;
export type PromoCodeTypes = string;

export interface StatisticData {
    category: PromoCodeCategory;
    batch: string;
}

export interface PrivatePromoCodeGenerationData {
    category: PromoCodeCategory;
    batch: string;
    description: string;
    type: PromoCodeTypes;
    expiration: string | null;
    count: number;
}

export interface PublicPromoCodeCreationData {
    code: string;
    category: PromoCodeCategory;
    description: string;
    type: PromoCodeTypes;
    expiration: string | null;
}

export interface PromoCode {
    type?: string | null;
    batch?: string | null;
    description?: string | null;
    category?: string | null;
    expiration?: string | null;

    iid?: string | null;
    bindAt?: string | null;

    consumedAt?: string | null;
    purchaseId?: string | null;

    publicConsumptionCount?: number | null;
}

export interface Statistic {
    totalCount: number;
    boundCount: number;
    consumedCount: number;
}

export interface Batch {
    id: string;
    description?: string | null;
}
